import type { FaireProductEntity } from "../../entity_types/product";

export const p_rvmv6w87j9: FaireProductEntity = {
  token: "p_rvmv6w87j9",
  type: "product",
  name: "Striped Large-capacity PVC Tote Bag for Women Shoulder Bag",
  brandToken: "b_785s5jxz4n",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/331289edd1f34d84027129b204b724632d300915c22f654dedbaaca85bbae3a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/84929537cc63c90f94508b66ab1f387f507b71a4263e9b94528a35883faab1b6.jpeg",
    "https://cdn.faire.com/fastly/b38b10e5a5af2f5ccca7d79adca227bfa97174d16ded3a373c3f9c850657a108.jpeg",
    "https://cdn.faire.com/fastly/ce1cfe033049092c7e7de68cebc8a6274a10ac88a2ae40a5e4b37b78e10f214c.jpeg",
    "https://cdn.faire.com/fastly/0f2606a016b4d17579b63e794316c6cccef6b614ec18014ebdd0e5afec2f3e04.jpeg",
    "https://cdn.faire.com/fastly/257a4c768dd66457df98f4621417d2482c35c487b827014bb35d3ea1109d13f2.jpeg",
    "https://cdn.faire.com/fastly/aac2a91124288891d91a43fda22a118ad4d8dd22439f5b9554f2325982731249.jpeg",
    "https://cdn.faire.com/fastly/b5c566230b700730f5ef0b026f06013daeaf6ea87bcde52df0cb9798f365b96e.jpeg",
    "https://cdn.faire.com/fastly/c97a3b5012b855315c2d02056c32b173773cadca2fef513f1844da1bb74f1aaf.jpeg",
    "https://cdn.faire.com/fastly/4f176a6122e9df9b07f896400539e2d1f9b24684462bd13123a254e559b4aa53.jpeg",
    "https://cdn.faire.com/fastly/3768f1047751bd7f1579d24d9ce094e911a6030c0da6f4d2b55ca8972a54f791.jpeg",
    "https://cdn.faire.com/fastly/cedc8bd70a9358856c12846cd7675fdd04095c896456f88d48e47cd75a004f1d.jpeg",
    "https://cdn.faire.com/fastly/5bd853b8f0ffcedd7a8efbdef088bfb90b74ac5ca6148a29f28b67f9903cd062.jpeg",
    "https://cdn.faire.com/fastly/2929533876a1e95ea2df4dc328758dfe04221ca47d305e71c0c7cb97476e9187.jpeg",
  ],
  priceDollars: 21.19,
  description:
    "High-Quality PVC Construction: This PVC Tote bag features superior PVC fabric that combines softness, comfort, and durability, with easy cleaning and care.\nSpacious Size: With dimensions of 45 cm (17.7 inches) in length, 31cm (12.2 inches) in height, and 13cm (5.1 inches) in width, offering ample space for daily essentials.\nChristmas gifts—from mini skincare sets and chocolate boxes to scarves and personalized trinkets—this chic tote doubles as a festive gift bag that’s as practical as it is stylish\nThe plastic tote bag features a convenient hook-and-loop closure (Velcro) for quick access\nThe letters print tote bag for women not only meets the needs of shopping, work, university, daily outings and city travel, but is also a thoughtful choice for friends and family on birthdays and festivals\nWarm Tips: To reduce our carbon footprint, the bags ship in compact folded packaging. When you receive the item, it may have some wrinkles, but after a few days it will return to its original shape.",
  tags: [],
  msrpDollars: 42.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:26.098Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
